import { render, staticRenderFns } from "./ProcessAssessment.vue?vue&type=template&id=1da120de&"
import script from "./ProcessAssessment.vue?vue&type=script&lang=js&"
export * from "./ProcessAssessment.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports